import { useEffect, useRef } from "react";
import { X } from "lucide-react";

const TOKEN = process.env.REACT_APP_INPOST_GEOWIDGET_TOKEN || "";
let loaded = false;

function loadAssets() {
  if (loaded) return;
  loaded = true;
  const css = document.createElement("link");
  css.rel = "stylesheet";
  css.href = "https://geowidget.inpost.pl/inpost-geowidget.css";
  document.head.appendChild(css);
  const js = document.createElement("script");
  js.src = "https://geowidget.inpost.pl/inpost-geowidget.js";
  js.defer = true;
  document.body.appendChild(js);
}

export const INPOST_ENABLED = !!TOKEN;

export default function InpostWidget({ open, onSelect, onClose, lang }) {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!open || !TOKEN) return;
    loadAssets();
    const handler = (e) => {
      const p = e.detail;
      if (p) {
        const addr = p.address ? `${p.address.line1 || ""} ${p.address.line2 || ""}`.trim() : "";
        onSelect({ name: p.name, address: addr });
        onClose();
      }
    };
    document.addEventListener("onpointselect", handler);
    return () => document.removeEventListener("onpointselect", handler);
  }, [open, onSelect, onClose]);

  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[120] flex items-center justify-center p-4" data-testid="inpost-modal">
      <div className="absolute inset-0 bg-[#1A243A]/70 backdrop-blur-sm" onClick={onClose} />
      <div className="relative w-full max-w-3xl bg-white rounded-3xl overflow-hidden shadow-2xl">
        <div className="flex items-center justify-between px-6 py-4 border-b border-[#E7E0D4]">
          <p className="font-display text-xl">{lang === "pl" ? "Wybierz paczkomat" : "Choose a locker"}</p>
          <button onClick={onClose} className="p-2 rounded-full hover:bg-[#F5F2EB]"><X size={20} /></button>
        </div>
        <div className="h-[70vh]" ref={containerRef}>
          {TOKEN ? (
            <inpost-geowidget token={TOKEN} language={lang === "pl" ? "pl" : "en"} config="parcelcollect" onpoint="onpointselect" style={{ width: "100%", height: "100%" }} />
          ) : (
            <div className="h-full flex items-center justify-center p-8 text-center text-[#64748B]">
              {lang === "pl"
                ? "Mapa paczkomatów wymaga tokenu InPost. Wpisz numer paczkomatu ręcznie w formularzu."
                : "The locker map requires an InPost token. Please enter the locker number manually."}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
